import { render } from "./PaginationPageView.vue?vue&type=template&id=45fb7582&scoped=true"
import script from "./PaginationPageView.vue?vue&type=script&lang=js"
export * from "./PaginationPageView.vue?vue&type=script&lang=js"

import "./PaginationPageView.vue?vue&type=style&index=0&id=45fb7582&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fb7582"]])

export default __exports__